// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            ...fontConfig.smallSingleLine,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                max-width: 100%;
                word-wrap: break-word;
            `,
        },
        css: css`
            flex-wrap: wrap;
            gap: 12px 8px;
        `,
    },
} as xBaseTheme["breadcrumbs"];
